import { ReactNode, useEffect, useState } from "react";
import { Logout } from "./components/login_components/Logout";
import Header from "./components/generic_components/Header";
import RoutePages from "./routing/RoutePages";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import { SignInButton } from "./components/login_components/SignInButton";
import "bootstrap/dist/css/bootstrap.css";
import "./common/CommonStyle.css";
function App() {
  const logoutPage: ReactNode = <Logout />;

  const homePage: ReactNode = (
    <>
      <AuthenticatedTemplate>
        <RoutePages />
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <center>
          <h4>Sign in to access SIM Documents</h4>
          <SignInButton />
        </center>
      </UnauthenticatedTemplate>
    </>
  );

  const pages = {
    mainPageKey: homePage,
    logoutPageKey: logoutPage,
  };

  const [pageContent, setPageContent] = useState<ReactNode>(homePage);

  return (
    <div className="padding-container">
      <Header pages={pages} setPage={setPageContent} />
      <>{pageContent}</>
    </div>
  );
}

export default App;
